export const NAV_LINKS = [
  { id: "home", label: "Overview" },
  { id: "services", label: "What We Do" },
  { id: "about", label: "Our Story" },
  { id: "blog", label: "Insights" },
  { id: "contact", label: "Let's Talk" },
];

export const RAIL_SECTIONS = [
  { id: "hero", label: "Intro" },
  { id: "positioning", label: "Positioning" },
  { id: "services", label: "Services" },
  { id: "digital", label: "Digital" },
  { id: "content", label: "Content" },
  { id: "performance", label: "Growth" },
  { id: "approach", label: "Approach" },
  { id: "differentiator", label: "Difference" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const ECOSYSTEM = [
  { n: "01", title: "Brand", items: ["Branding", "Brand Identity", "Graphic Design"] },
  { n: "02", title: "Digital", items: ["Website Development", "Landing Pages", "E-commerce", "Online Store Setup"] },
  { n: "03", title: "Content", items: ["Content Creation", "Social Content", "Ad Shoots", "Campaign Shoots"] },
  { n: "04", title: "Growth", items: ["Social Media Management", "Meta Ads", "Google Ads", "SEO"] },
  { n: "05", title: "Systems", items: ["Marketing Automations", "Business Workflows", "AI Systems"] },
];

export const CAPABILITIES = [
  { n: "01", title: "Brand", desc: "Build a brand people remember.", items: ["Brand Strategy", "Brand Identity", "Graphic Design", "Visual Systems"] },
  { n: "02", title: "Digital", desc: "Build a digital presence that works.", items: ["Websites", "Landing Pages", "E-commerce", "Online Stores"] },
  { n: "03", title: "Content", desc: "Create reasons for people to stop and pay attention.", items: ["Content Creation", "Social Content", "Ad Shoots", "Campaign Production"] },
  { n: "04", title: "Performance", desc: "Put your business in front of the right people.", items: ["Social Media", "Meta Ads", "Google Ads", "SEO"] },
  { n: "05", title: "Systems", desc: "Make growth more efficient.", items: ["Marketing Automation", "Lead Systems", "Business Workflows", "AI Systems"] },
];

export const APPROACH = [
  { n: "01", title: "Understand", body: "Your business. Your audience. Your goals." },
  { n: "02", title: "Strategise", body: "Find what actually needs to be built." },
  { n: "03", title: "Create", body: "Build the brand, content and digital experience." },
  { n: "04", title: "Grow", body: "Launch, measure and improve." },
];

export const DIFFERENTIATORS = [
  "Strategy before execution.",
  "Business before trends.",
  "Clarity before complexity.",
  "Growth before vanity.",
];

export const AUDIENCE = ["Founders", "Growing Businesses", "Retail Brands", "D2C Brands", "Local Businesses", "New Ventures"];

export const WEBSITE_FLOW = ["Landing Page", "Business Website", "Advanced Website", "E-commerce", "Digital Systems"];
export const CONTENT_FLOW = ["Idea", "Concept", "Shoot", "Create", "Publish", "Amplify"];
